/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show hidden edges</h4>

<p>Switch between hidden edges and only visible edges viewing mode.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>H</b>: Show/hide hidden edges</li>
</ul>`;

export default function ShowHiddenEdgesTooltip() {
    return h('div', { innerHTML: body });
}
